'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudioMarkerCluster = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MARKER_RISE_Z_INDEX_OFFSET = 300; /* globals L */

// We have this ^^ because the Leaflet lib cannot be loaded on the server as it
// expects `window` and `document` to be available. We inject Leaflet at build
// time in webpack.dev/prod.js.

var StudioMarkerCluster = exports.StudioMarkerCluster = function (_React$PureComponent) {
  (0, _inherits3.default)(StudioMarkerCluster, _React$PureComponent);

  function StudioMarkerCluster() {
    (0, _classCallCheck3.default)(this, StudioMarkerCluster);
    return (0, _possibleConstructorReturn3.default)(this, (StudioMarkerCluster.__proto__ || (0, _getPrototypeOf2.default)(StudioMarkerCluster)).apply(this, arguments));
  }

  (0, _createClass3.default)(StudioMarkerCluster, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // In order to use L.markerClusterGroup, must load leaflet markercluster,
      // which cannot be loaded on the server as it expects `window` and
      // `document` to be available.
      if (__CLIENT__ || __TEST__) {
        /* eslint-disable-next-line import/no-unresolved */
        require('leaflet.markercluster');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var studios = this.props.studios;


      if (studios && nextProps.studios && studios.length !== nextProps.studios.length) {
        this.context.map.removeLayer(this.markerClusterGroup);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.context.map.removeLayer(this.markerClusterGroup);
    }
  }, {
    key: 'getStudioIconClasses',
    value: function getStudioIconClasses(studio, markerClassNames) {
      var _studio$activities = studio.activities,
          activities = _studio$activities === undefined ? [] : _studio$activities;


      if (typeof activities === 'string') {
        activities = activities.split(',').map(function (activity) {
          return activity.trim();
        });
      }

      var activityClasses = activities.map(function (activity) {
        return 'map__marker__activity--' + activity.toLowerCase().replace(/[^a-z]/g, '');
      });
      return _classnames2.default.apply(undefined, ['map__marker', 'map__marker-studio' + studio.id].concat((0, _toConsumableArray3.default)(activityClasses), [markerClassNames]));
    }
  }, {
    key: 'createStudioMarkers',
    value: function createStudioMarkers() {
      var _this = this;

      return (this.props.studios || []).reduce(function (result, studio) {
        if (studio.location) {
          var markerOptions = (_this.props.clusterOptions || {}).markers;
          var icon = new L.divIcon((0, _extends3.default)({ // eslint-disable-line new-cap
            className: _this.getStudioIconClasses(studio)
          }, markerOptions));
          var marker = L.marker([studio.location.lat, studio.location.lon], {
            icon: icon
          });
          marker.on('click', function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            if (markerOptions.activeClassName) {
              if (_this.activeMarker && _this.activeMarker._icon) {
                // eslint-disable-line no-underscore-dangle
                _this.activeMarker.setZIndexOffset(0);
                L.DomUtil.removeClass(_this.activeMarker._icon, markerOptions.activeClassName); // eslint-disable-line no-underscore-dangle
              }
              L.DomUtil.addClass(marker._icon, markerOptions.activeClassName); // eslint-disable-line no-underscore-dangle
              marker.setZIndexOffset(MARKER_RISE_Z_INDEX_OFFSET);
              _this.activeMarker = marker;
            }
            if (_this.props.onMarkerSelected) {
              var _this$props;

              (_this$props = _this.props).onMarkerSelected.apply(_this$props, [studio].concat(args));
            }
          });
          marker.on('mouseover', function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            if (markerOptions.hoverClassName) {
              L.DomUtil.addClass(marker._icon, markerOptions.hoverClassName); // eslint-disable-line no-underscore-dangle
            }
            if (_this.props.onMarkerMouseIn) {
              var _this$props2;

              (_this$props2 = _this.props).onMarkerMouseIn.apply(_this$props2, [studio].concat(args));
            }
          });
          marker.on('mouseout', function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }

            if (markerOptions.hoverClassName) {
              L.DomUtil.removeClass(marker._icon, markerOptions.hoverClassName); // eslint-disable-line no-underscore-dangle
            }
            if (_this.props.onMarkerMouseOut) {
              var _this$props3;

              (_this$props3 = _this.props).onMarkerMouseOut.apply(_this$props3, [studio].concat(args));
            }
          });

          result.push(marker);
        } else {
          // eslint-disable-next-line no-console
          console.warn('Studio with no location', studio);
        }
        return result;
      }, []);
    }
  }, {
    key: 'render',
    value: function render() {
      var clusterOptions = this.props.clusterOptions;
      var map = this.context.map;


      if (this.markerClusterGroup) {
        map.removeLayer(this.markerClusterGroup);
      }
      this.markerClusterGroup = L.markerClusterGroup(clusterOptions);
      map.addLayer(this.markerClusterGroup);
      this.markerClusterGroup.addLayers(this.createStudioMarkers());
      return null;
    }
  }]);
  return StudioMarkerCluster;
}(_react2.default.PureComponent);

StudioMarkerCluster.propTypes = {
  clusterOptions: _propTypes2.default.object,
  studios: _propTypes2.default.array,
  onMarkerSelected: _propTypes2.default.func,
  onMarkerMouseIn: _propTypes2.default.func,
  onMarkerMouseOut: _propTypes2.default.func
};

StudioMarkerCluster.contextTypes = {
  map: _propTypes2.default.object
};